import _asyncToGenerator from "/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/workspace/node_modules/@babel/runtime/regenerator";
import pTimeout from 'p-timeout';
export default function pWaitFor(_x) {
  return _pWaitFor.apply(this, arguments);
}

function _pWaitFor() {
  _pWaitFor = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(condition) {
    var options,
        _options$interval,
        interval,
        _options$timeout,
        timeout,
        _options$before,
        before,
        retryTimeout,
        promise,
        _args2 = arguments;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
            _options$interval = options.interval, interval = _options$interval === void 0 ? 20 : _options$interval, _options$timeout = options.timeout, timeout = _options$timeout === void 0 ? Number.POSITIVE_INFINITY : _options$timeout, _options$before = options.before, before = _options$before === void 0 ? true : _options$before;
            promise = new Promise(function (resolve, reject) {
              var check = /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                  var value;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.prev = 0;
                          _context.next = 3;
                          return condition();

                        case 3:
                          value = _context.sent;

                          if (!(typeof value !== 'boolean')) {
                            _context.next = 6;
                            break;
                          }

                          throw new TypeError('Expected condition to return a boolean');

                        case 6:
                          if (value === true) {
                            resolve();
                          } else {
                            retryTimeout = setTimeout(check, interval);
                          }

                          _context.next = 12;
                          break;

                        case 9:
                          _context.prev = 9;
                          _context.t0 = _context["catch"](0);
                          reject(_context.t0);

                        case 12:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, null, [[0, 9]]);
                }));

                return function check() {
                  return _ref.apply(this, arguments);
                };
              }();

              if (before) {
                check();
              } else {
                retryTimeout = setTimeout(check, interval);
              }
            });

            if (!(timeout !== Number.POSITIVE_INFINITY)) {
              _context2.next = 14;
              break;
            }

            _context2.prev = 4;
            _context2.next = 7;
            return pTimeout(promise, timeout);

          case 7:
            return _context2.abrupt("return", _context2.sent);

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](4);

            if (retryTimeout) {
              clearTimeout(retryTimeout);
            }

            throw _context2.t0;

          case 14:
            return _context2.abrupt("return", promise);

          case 15:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[4, 10]]);
  }));
  return _pWaitFor.apply(this, arguments);
}